/**********************************************
 * registration-bp (Business Partner) events  *
 **********************************************/

$('body').on('click', '.btn_to_step_1', function () {
    iris.setButtonLoadingByReference('.btn_to_step_1');
    iris.unsetButtonLoadingByReference('.btn_to_step_2');
    iris.unsetButtonLoadingByReference('.btn_to_step_3');
    iris.unsetButtonLoadingByReference('#register');
    $('#circle1').addClass('active');
    $('#circle2').removeClass('active');
    $('#circle3').removeClass('active');
    $('#circle4').removeClass('active');
    $('#tab1').addClass('active');
    $('#tab2').removeClass('active');
    $('#tab3').removeClass('active');
    $('#tab4').removeClass('active')
    $('.sidebar-right').show();
});

$('body').on('click', '.btn_to_step_2', function () {
    iris.setButtonLoadingByReference('.btn_to_step_2');
    iris.unsetButtonLoadingByReference('.btn_to_step_1');
    iris.unsetButtonLoadingByReference('.btn_to_step_3');
    iris.unsetButtonLoadingByReference('#register');
    $('#circle1').removeClass('active');
    $('#circle2').addClass('active');
    $('#circle3').removeClass('active');
    $('#circle4').removeClass('active');
    $('#tab1').removeClass('active');
    $('#tab2').addClass('active');
    $('#tab3').removeClass('active');
    $('#tab4').removeClass('active');
    $('.sidebar-right').hide();
});

$('body').on('click', '.btn_to_step_3', function () {
    iris.setButtonLoadingByReference('.btn_to_step_3');
    iris.unsetButtonLoadingByReference('.btn_to_step_1');
    iris.unsetButtonLoadingByReference('.btn_to_step_2');
    iris.unsetButtonLoadingByReference('#register');
    $('#circle1').removeClass('active');
    $('#circle2').removeClass('active');
    $('#circle3').addClass('active');
    $('#circle4').removeClass('active');
    $('#tab1').removeClass('active');
    $('#tab2').removeClass('active');
    $('#tab3').addClass('active');
    $('#tab4').removeClass('active');
});

$('body').on('click', '#register', function () {
    iris.setButtonLoadingByReference('#register');
    iris.unsetButtonLoadingByReference('.btn_to_step_1');
    iris.unsetButtonLoadingByReference('.btn_to_step_2');
    iris.unsetButtonLoadingByReference('.btn_to_step_3');
    $('form#registration').submit();
});